export const landing5 = {
  hero: {
    title: "Automate your business, grow your revenue",
    subtitle: "Website, booking, marketing - all automated with AI. More clients, less admin work.",
    cta: "Request free callback",
    secondaryCta: "See how it works",
  },
  proofPoints: {
    title: "Why Bespire?",
    items: [
      {
        value: "90%",
        label: "Time Saved",
        description: "Reduction in time spent on admin tasks",
      },
      {
        value: "10 min",
        label: "Setup",
        description: "Website and booking system ready in minutes",
      },
      {
        value: "24/7",
        label: "Availability",
        description: "Your clients can book appointments anytime",
      },
    ],
  },
  featureTabs: {
    title: "Everything you need - in one place",
    subtitle: "Website, booking, marketing - integrated, not scattered",
    tabs: [
      {
        id: "website",
        title: "Website Builder",
        icon: "globe",
        headline: "Professional website in minutes",
        description: "The AI assistant asks questions, then automatically builds you a professional website. Logo, colors, content - everything tailored to your brand.",
        features: [
          "Ready in minutes",
          "Mobile-friendly modern design",
          "Use your own domain",
          "Built-in sales and payment system",
        ],
      },
      {
        id: "booking",
        title: "Booking System",
        icon: "calendar",
        headline: "A booking system that actually works",
        description: "Your clients can book appointments 24/7, you send automatic reminders, and you always see your calendar in one place.",
        features: [
          "Unified with your website, no external system",
          "Guests sign in on your website",
          "Multiple staff management",
          "Automatic pass and membership management",
        ],
      },
      {
        id: "marketing",
        title: "Marketing Automation",
        icon: "megaphone",
        headline: "Marketing that runs itself",
        description: "AI helps you create content, run campaigns and acquire new clients - without marketing knowledge.",
        features: [
          "AI-generated social media posts",
          "Email marketing campaigns",
          "Client recall system",
          "Analytics and suggestions",
        ],
      },
      {
        id: "payments",
        title: "Payments & Invoicing",
        icon: "creditCard",
        headline: "Simple and transparent finances",
        description: "Online payment, on-site payment, invoicing - manage everything in one place. Automatic invoice generation for every transaction.",
        features: [
          "Online card payment",
          "Apple Pay and Google Pay",
          "Automatic invoicing",
          "On-site payment with no commission",
        ],
      },
      {
        id: "clients",
        title: "Client Management",
        icon: "users",
        headline: "Know your clients better",
        description: "Client cards, treatment history, preferences - everything in one place to provide a personalized experience.",
        features: [
          "Detailed client profiles",
          "Treatment history tracking",
          "Tagging and segmentation",
          "Loyalty program management",
        ],
      },
      {
        id: "analytics",
        title: "Analytics",
        icon: "barChart",
        headline: "Data-driven decisions",
        description: "Detailed reports on bookings, revenue, and client activity. Know what works and what doesn't.",
        features: [
          "Revenue reports and trends",
          "Booking statistics",
          "Client activity analysis",
          "Exportable reports",
        ],
      },
    ],
  },
  exclusiveFeatures: {
    title: "What can you sell on your website?",
    subtitle: "Multiple revenue streams, one platform - to grow your business",
  },
  growthLevers: {
    title: "Growth Tools",
    subtitle: "Extra features to accelerate your growth",
    items: [
      {
        title: "AI Assistant",
        description: "AI credits are like magic tokens: website generation, image creation, marketing content, business suggestions - all automated. You get 100 free credits to start.",
        features: [
          "Website generation",
          "Marketing content creation",
          "Image generation",
          "Business suggestions",
        ],
      },
      {
        title: "Quick Start",
        description: "Already have a website? AI reviews it and imports your texts, images, and services. Don't have anything yet? AI asks questions and builds everything from scratch.",
        features: [
          "Import existing website",
          "Question-based site building",
          "Ready in 10 minutes",
          "Start selling immediately",
        ],
      },
    ],
  },
  testimonials: {
    title: "What our clients say",
    subtitle: "Service providers who already use Bespire",
    items: [
      {
        name: "Eva Nagy",
        role: "Hairdresser",
        location: "Budapest",
        text: "After 3 years, I finally have a professional website and don't have to be on the phone all day for bookings. Bespire automated everything.",
        rating: 5,
      },
      {
        name: "Mark Kovacs",
        role: "Personal Trainer",
        location: "Debrecen",
        text: "I used to have 10-15 clients, now I have 40+ regulars. The online booking and marketing AI worked wonders.",
        rating: 5,
      },
      {
        name: "Fitness Plus Studio",
        role: "Yoga and Pilates Studio",
        location: "Szeged",
        text: "We work with 6 instructors and the calendar used to be chaos. Now everything is organized, clients are happy, and we save time.",
        rating: 5,
      },
      {
        name: "Reka Toth",
        role: "Beautician",
        location: "Győr",
        text: "Since the automatic reminders, there are almost no no-shows. Pass management is simple too, my clients love the online booking.",
        rating: 5,
      },
      {
        name: "Andras Szabo",
        role: "Business Coach",
        location: "Pécs",
        text: "Marketing automation brought the most value. The AI writes social media posts, and I focus on my clients.",
        rating: 5,
      },
      {
        name: "Anna Kiss",
        role: "Massage Therapist",
        location: "Miskolc",
        text: "I work alone and Bespire is like a personal assistant. Booking, reminders, payments - everything runs automatically.",
        rating: 5,
      },
    ],
  },
  categoryLinks: {
    title: "Who is Bespire for?",
    subtitle: "We help a wide range of service providers in their daily work",
    viewAll: "View all",
  },
  newsletterCta: {
    title: "Ready to get started?",
    subtitle: "Join the waitlist and be among the first to try Bespire.",
    cta: "Request free callback",
  },
};
